import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    description: 'ordersDrawer.awaitingPayment.header',
    defaultMessage: 'This Order is Awaiting Payment',
    id: 'nMqd9L',
  },
  instructions: {
    description: 'ordersDrawer.awaitingPayment.instructions',
    defaultMessage: "To create a label, you'll need to mark this order as paid.",
    id: '4HXw7j',
  },
  markAsPaid: {
    description: 'ordersDrawer.awaitingPayment.markAsPaid',
    defaultMessage: 'Mark as Paid',
    id: 'TNCIUa',
  },
});
